module.exports = __webpack_public_path__ + "img/logo_dk@2x.5b4b3946.png";